{
  "DATA_ASSISTANT": {
    "TITLE": "Datu asistents",
    "NEW_CONVERSATION": "+ Jauns",
    "LOADING": "Notiek ielāde...",
    "LOADING_MESSAGES": "Notiek ziņojumu ielāde...",
    "THINKING": "Domā...",
    "UNTITLED": "Saruna bez nosaukuma",
    "NO_CONVERSATIONS": "Vēl nav sarunu. Noklikšķiniet uz \"+ Jauns\", lai sāktu.",
    "EMPTY_STATE": "Izvēlieties sarunu vai izveidojiet jaunu, lai sāktu.",
    "PLACEHOLDER": "Ko es varu Jums noskaidrot?",
    "SHOW_SQL": "Rādīt SQL",
    "NO_ROWS": "Nav atgrieztas nevienas rindas.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Dzēst sarunu",
    "DELETE_CONFIRM_DESCRIPTION": "Vai tiešām vēlaties dzēst šo sarunu? Šo darbību nevar atsaukt.",
    "DELETE_CONFIRM_YES": "Dzēst",
    "REPORTS": "Pārskati",
    "SAVE_TO_REPORT": "Saglabāt pārskatā",
    "NEW_REPORT": "Jauns pārskats",
    "REPORT_NAME": "Pārskata nosaukums",
    "NO_REPORTS": "Vēl nav saglabātu pārskatu",
    "REPORTS_EMPTY_STATE": "Izvēlieties pārskatu vai izveidojiet jaunu.",
    "REPORT_SAVED": "Saglabāts pārskatā",
    "DELETE_REPORT_CONFIRM": "Dzēst pārskatu",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Vai tiešām vēlaties dzēst šo pārskatu? Visi saglabātie vienumi tiks noņemti.",
    "DELETE_ITEM_CONFIRM": "Noņemt vienumu",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Vai tiešām vēlaties noņemt šo vienumu no pārskata?",
    "EXPORT_CSV": "Eksportēt CSV",
    "REFRESH": "Atsvaidzināt",
    "QUERY_RUNNING": "Notiek vaicājuma izpilde...",
    "QUERY_FAILED": "Vaicājums neizdevās",
    "AUTO_REFRESH": "Automātiska atsvaidzināšana",
    "AUTO_REFRESH_NONE": "Manuāli",
    "AUTO_REFRESH_30S": "30 sekundes",
    "AUTO_REFRESH_1M": "1 minūte",
    "AUTO_REFRESH_5M": "5 minūtes",
    "AUTO_REFRESH_10M": "10 minūtes",
    "EDIT_MESSAGE": "Rediģēt ziņojumu",
    "RENAME_REPORT": "Pārdēvēt pārskatu",
    "RENAME_ITEM": "Pārdēvēt vienumu",
    "MOVE_UP": "Pārvietot uz augšu",
    "MOVE_DOWN": "Pārvietot uz leju",
    "COLLABORATORS": {
      "BUTTON": "Līdzstrādnieki",
      "TITLE": "Pārskata līdzstrādnieki",
      "DESCRIPTION": "Izvēlieties, kuri aģenti un komandas var skatīt šo pārskatu.",
      "AGENTS": "Aģenti",
      "TEAMS": "Komandas",
      "SELECT_AGENTS": "Izvēlēties aģentus",
      "SELECT_TEAMS": "Izvēlēties komandas",
      "SAVE": "Saglabāt",
      "SAVED": "Līdzstrādnieki atjaunināti",
      "SAVE_FAILED": "Neizdevās atjaunināt līdzstrādniekus"
    }
  }
}
